export type WooZip = {
	url: string;
	ext: string;
	mime: 'string';
	size?: number;
	name?: string;
};

export const instanceOfWooZip = (object: any): object is WooZip =>
	typeof object === 'object' &&
	'url' in object &&
	typeof object.url === 'string' &&
	'ext' in object &&
	typeof object.ext === 'string' &&
	'mime' in object &&
	typeof object.mime === 'string' &&
	(('size' in object && typeof object.size === 'number') || !('size' in object)) &&
	(('name' in object && typeof object.name === 'string') || !('name' in object));

export const instanceOfWooZipArray = (array: any): array is WooZip[] =>
	Array.isArray(array) && array.length > 0 && array.every((item) => instanceOfWooZip(item));
